<template>
  <transition name="modal-fade">
    <div v-if="isActive" :class="{'body': toBody, 'lightbox': src !== ''}">
      <div class="modal is-active" :class="compClasses">
        <div class="modal-background" @click="close('backdrop')"></div>
        <div class="modal-card" v-if="image === ''">
          <header class="modal-card-head">
            <p class="modal-card-title">{{title}}</p>
          </header>
          <section class="modal-card-body">
            <slot name="body"></slot>
          </section>
          <footer class="modal-card-foot" @click="defaultClick">
            <slot name="footer"></slot>
          </footer>
        </div>
        <figure class="modal-card" v-else>
          <loader v-if="!ready" :loading="true" :fixed="false"></loader>
          <img ref="image" :src="src" />
        </figure>
      </div>
    </div>
  </transition>
</template>

<script>

import loader from '@/components/Loader.vue'

export default {
  name: 'viaModal',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    closeOnBackdrop: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    autoClose: {
      type: Boolean,
      default: true
    },
    toBody: {
      type: Boolean,
      default: false
    },
    image: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      icons: {},
      src: '',
      isActive: this.active || false,
      ready: false
    }
  },
  components: {
    loader
  },
  computed: {
    compClasses () {
      return [this.size]
    }
  },
  watch: {
    active (value) {
      this.isActive = value
    },
    image (value) {
      var self = this
      self.src = ''
      self.isActive = value !== ''
      self.ready = false
      if (self.isActive) {
        self.$nextTick(() => {
          var img = self.$refs.image
          img.onload = function () {
            self.$nextTick(() => {
              self.ready = true
            })
          }
          self.src = value
        })
      }
    }
  },
  beforeMount () {
    if (typeof window !== 'undefined' && this.toBody) {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
      })
    }
  },
  mounted () {

  },
  methods: {
    close (source) {
      var self = this
      if (source === 'backdrop' && !self.closeOnBackdrop) return
      self.$emit('close')
      self.$emit('update:active', false)
      self.isActive = false
    },
    defaultClick (e) {
      if (
        this.autoClose &&
        ['BUTTON', 'INPUT', 'A'].indexOf(e.target.nodeName) !== -1
      ) { this.close() }
    }
  }
}
</script>

<style lang="scss" scoped>

.modal-fade-enter-active,
.modal-fade-leave-active,
.image-fade-enter-active,
.image-fade-leave-active {
  transition: opacity .2s;
}
.modal-fade-enter,
.modal-fade-leave-to,
.image-fade-enter,
.image-fade-leave-to{
  opacity: 0;
}

.body{
  z-index: 1011;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.modal {

  .modal-card {
    color: $grey-darker;
    width: auto;
    height: auto;
    .modal-card-body{
      position: relative;
    }
  }
  &.xs{
    .modal-card{
      width: 300px;
      max-width: 300px;
    }
  }
  &.sm {
    .modal-card {
      width: 450px;
      max-width: 100%;
    }
  }
  &.md {
    .modal-card {
      width: 600px;
      max-width: 100%;
    }
  }
  &.lg {
    .modal-card {
      width: 900px;
      max-width: 100%;
    }
  }
  &.xl {
    .modal-card {
      width: 1200px;
      max-width: 100%;
    }
  }

  footer {
    background-color: $white;
    border: none;
    // justify-content: flex-end;
    /deep/.is-pulled-right{
      margin-left: auto;
    }
  }
}
.lightbox{
  .modal-card{
    min-width: 50px;
    min-height: 50px;
    max-width: 80%;
    max-height: 80%;
    width: auto;
    height: auto;
    padding: 4px;
    background-color: $white;
    border-radius: 4px;

    img{
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>
